import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteAppointment(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteAppointment = (appointmentId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`appointments/${appointmentId}/`);
  };

  return useMutation(deleteAppointment, {
    onSuccess: () => {
      queryClient.removeQueries('appointments');
    },
  });
}
